import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en/translation.json";
import pt from "./locales/pt/translation.json";

const resources = {
  en: {
    translation: en,
  },
  pt: {
    translation: pt,
  },
};

type LangCode = "en" | "pt";

const savedLang =
  typeof window !== "undefined"
    ? (localStorage.getItem("atlante_lang") as LangCode | null)
    : null;

const defaultLang: LangCode = "pt";

i18n.use(initReactI18next).init({
  resources,
  lng: savedLang ?? defaultLang,
  fallbackLng: defaultLang,
  supportedLngs: ["en", "pt"],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
